// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"1dca7258","977":"38912e71"}[chunkId] + ".chunk.js";
};